// import React from "react";
// import { IoClose } from "react-icons/io5";
// import "./Cart.css"
// import { FaArrowLeftLong } from "react-icons/fa6";
// import { useCart } from "../CartContext/CartContext";
// import { FaRupeeSign } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// const CartPage = () => {
//     const { cartItems, removeFromCart, clearCart } = useCart();
//     console.log(cartItems);
//     const navigate = useNavigate();
//     const isLoggedIn = localStorage.getItem("token");
//     // Calculate total price
//     const totalPrice = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);

//     return (
//         <div className="">
//             <div className="breadcrumb-wrap bg-f br-2">
//                 <div className="container">
//                     <div className="breadcrumb-title">
//                         <h2>Shopping Cart</h2>
//                         <ul className="breadcrumb-menu list-style">
//                             <li><Link to="/">Home </Link></li>
//                             <li>Shopping Cart</li>
//                         </ul>
//                     </div>
//                 </div>
//             </div>

//             <div className=" containerorder">
//                 <a href="/products" style={{display:"flex",alignItems:"center" ,color:"#243011" ,}}> <FaArrowLeftLong />Back To Products</a>
//                 {cartItems.length === 0 ? (
//                     <p>Your cart is empty.</p>
//                 ) : (
//                     <div className="continercart">

//                         {cartItems.map((item, index) => (
//                             <div key={index} className="cartcontiner">
//                                 <div>
//                                     <img
//                                         src={`${item.image}`}
//                                         alt={item.productName}
//                                         style={{ width: "100%", height: "20vh", objectFit: "contain" }}
//                                     />

//                                 </div>
//                                 <div>{item.productName}</div>
//                                 <div>Size: {item.size}</div>
//                                 {/* <li>
//                                         <FaRupeeSign /> {item.price}
//                                     </li> */}
//                                 <div>Quantity: {item.quantity}</div>
//                                 <div>

//                                     Rs. {item.price * item.quantity}
//                                 </div>
//                                 <div>
//                                     <button
//                                         className="closebuttoncart"
//                                         onClick={() => removeFromCart(item.id, item.sizeId)}
//                                     >
//                                         <IoClose size={24} />
//                                     </button>
//                                 </div>
//                             </div>
//                         ))}


//                         <div className="d-flex justify-content-between align-items-center mt-4">
//                             <button className="btn btn-secondary" onClick={clearCart}>
//                                 Clear Cart
//                             </button>
//                             <h4>
//                                 Total: <FaRupeeSign /> {totalPrice}
//                             </h4>
//                             {/* <button
//                             className="btn btn-primary"
//                             onClick={() => navigate("/Checkout")}
//                         >
//                             Proceed to Checkout
//                         </button> */}

//                             <button
//                                 className={`btn btn-primary ${!isLoggedIn ? '' : ''}`}
//                                 onClick={() => {
//                                     if (isLoggedIn) {
//                                         navigate('/checkout');
//                                     } else {
//                                         navigate('/login', { state: { from: '/checkout' } });
//                                     }
//                                 }}
//                             >
//                                 {isLoggedIn ? 'CHECKOUT' : 'LOGIN TO CHECKOUT'}
//                             </button>
//                             {!isLoggedIn && (
//                                 <div className="login-message">
//                                     Please login to proceed with checkout
//                                 </div>
//                             )}
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default CartPage;

import React from 'react';
import { useCart } from "../CartContext/CartContext";
import { useNavigate, Link } from "react-router-dom";
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  Grid,
  IconButton,
  Divider,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const CartPage = () => {
  const { cartItems, removeFromCart, clearCart } = useCart();
  const navigate = useNavigate();
  const totalPrice = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const isLoggedIn = localStorage.getItem("token");
  if (cartItems.length === 0) {
    return (
      <>
        <div className="breadcrumb-wrap bg-f br-2">
          <div className="container">
            <div className="breadcrumb-title">
              <h2>Shopping Cart</h2>
              <ul className="breadcrumb-menu list-style">
                <li><Link to="/">Home </Link></li>
                <li>Shopping Cart</li>
              </ul>
            </div>
          </div>
        </div>
        <Container maxWidth="xl" sx={{ py: 4 }}>

          <Box sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            mb: 4,
            mt: 2
          }}>
             <h6 class="fw-normal mb-0">
                  <Link to="/products"><FaArrowLeft /> Back to list</Link>
                </h6>
            
          </Box>
          <Typography>Your cart is empty.</Typography>
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="breadcrumb-wrap bg-f br-2">
        <div className="container">
          <div className="breadcrumb-title">
            <h2>Shopping Cart</h2>
            <ul className="breadcrumb-menu list-style">
              <li><Link to="/">Home </Link></li>
              <li>Shopping Cart</li>
            </ul>
          </div>
        </div>
      </div>
      {/* <Container maxWidth="xl" sx={{ py: 4 }}>
      
        <Box sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          mb: 4,

        }}>
          <Button
            component={Link}
            to="/products"
            startIcon={<ArrowBackIcon />}
            sx={{ color: '#1976d2', position: 'absolute', left: 0 }}
          >
            CONTINUE SHOPPING
          </Button>

        </Box>

        <Grid container spacing={6} sx={{ justifyContent: 'space-between' }}>
   
          <Grid item xs={12} md={8.5}>
            <Paper sx={{ mb: 3, overflow: 'hidden', width: '100%', bgcolor: 'white' }}>
      
              <Box sx={{
                display: 'grid',
                gridTemplateColumns: '1fr 2.5fr 1fr 1fr',
                bgcolor: '#1976d2',
                p: 2
              }}>
                <Typography sx={{ color: 'white', fontWeight: 500 }}>Product</Typography>
                <Typography sx={{ color: 'white', fontWeight: 500 }}>Details</Typography>
                <Typography sx={{ color: 'white', fontWeight: 500, textAlign: 'center' }}>Price</Typography>
                <Typography sx={{ color: 'white', fontWeight: 500, textAlign: 'center' }}>Actions</Typography>
              </Box>

          
              {cartItems.map((item, index) => (
                <Box key={index} sx={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 2.5fr 1fr 1fr',
                  p: 2,
                  alignItems: 'center',
                  borderBottom: '1px solid #eee'
                }}>
                  <Box sx={{ p: 1 }}>
                    <Box sx={{
                      width: 100,
                      height: 100,
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: 1,
                      boxShadow: '0 0 10px rgba(0,0,0,0.05)'
                    }}>
                      <img
                        src={`${item.image}`}
                        alt={item.productName}
                        style={{ maxWidth: '90%', maxHeight: '90%', objectFit: 'contain' }}
                      />
                    </Box>
                  </Box>
                  <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                      {item.productName}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                      Size: {item.size}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', mt: 0.5 }}>
                      Quantity: {item.quantity}
                    </Typography>
                  </Box>
                  <Typography sx={{ textAlign: 'center', color: '#333' }}>
                    ₹{item.price}
                  </Typography>
                  <Box sx={{ textAlign: 'center' }}>
                    <IconButton
                      color="error"
                      onClick={() => removeFromCart(item.id, item.sizeId)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </Box>
              ))}
            </Paper>
          </Grid>

       
          <Grid item xs={12} md={3}>
            <Paper sx={{ p: 3, bgcolor: 'white' }}>
              <Typography variant="h6" sx={{ mb: 3, color: '#333', fontWeight: 500 }}>
                Order Summary
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Typography sx={{ color: '#666' }}>Subtotal</Typography>
                <Typography sx={{ color: '#333' }}>₹{totalPrice}</Typography>
              </Box>

              <Divider sx={{ my: 3 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                <Typography sx={{ fontWeight: 500, color: '#333' }}>Total</Typography>
                <Typography sx={{ fontWeight: 500, color: '#333' }}>₹{totalPrice}</Typography>
              </Box>
              
              <Button
                className={`btn btn-primary ${!isLoggedIn ? '' : ''}`}

                onClick={() => {
                  if (isLoggedIn) {
                    navigate('/checkout');
                  } else {
                    navigate('/login', { state: { from: '/checkout' } });
                  }
                }}
              >
                {isLoggedIn ? 'CHECKOUT' : 'LOGIN TO CHECKOUT'}
              </Button>
              <Button
                variant="outlined"
                fullWidth
                sx={{
                  color: 'error.main',
                  borderColor: 'error.main',
                  '&:hover': {
                    borderColor: 'error.dark',
                    bgcolor: 'error.light'
                  }
                }}
                onClick={clearCart}
              >
                CLEAR CART
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Container> */}

      <section class="h-100">
        <div class="container h-100 py-5">
          <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col-10">

              <div class="d-flex justify-content-between align-items-center mb-4">
                <h6 class="fw-normal mb-0">
                  <Link to="/products"><FaArrowLeft /> Back to list</Link>
                </h6>

              </div>

              {cartItems.map((item, index) => (<div class="card rounded-3 mb-4">
                <div class="card-body p-4">
                  <div class="row d-flex justify-content-between align-items-center">
                    <div class="col-md-2 col-lg-2 col-xl-2">
                      <img
                        src={`${item.image}`}
                        alt={item.productName}
                        class="img-fluid rounded-3" style={{ height: "200px" }} />
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2">
                      <p style={{ fontSize: "18px", textAlign: "justify" }}>{item.productName}</p>
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2">
                      <p style={{ fontSize: "18px", textAlign: "justify" }} className='new_karthik_heading_here'>Size:{item.size}</p>
                      <p style={{ fontSize: "18px", textAlign: "justify" }}>Quantity:{item.quantity}</p>
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2">
                      <h5 class="mb-0" className="new_karthik_heading_here">MRP ₹{item.price}.00</h5>
                    </div>
                    <div class="col-md-3 col-lg-2 col-xl-2 offset-lg-1">
                      <IconButton
                        color="error"
                        onClick={() => removeFromCart(item.id, item.sizeId)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </div>

                  </div>
                </div>
              </div>))}

              <div class="card">
                <div class="card-body">
                  <div class="row d-flex justify-content-between align-items-center">
                    <div class="col-md-2 col-lg-2 col-xl-4">
                      <h6 className="new_karthik_heading_here">MRP ₹{totalPrice}.00</h6>
                    </div>
                    <div class="col-md-2 col-lg-2 col-xl-4 mb-1">
                      <button type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-primary btn-sm" onClick={clearCart}>CLEAR CART</button>
                    </div>
                    <div class="col-md-2 col-lg-2 col-xl-4 mb-1">
                      
                      <button type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-success btn-sm" onClick={() => {
                        if (isLoggedIn) {
                          navigate('/checkout');
                        } else {
                          navigate('/login', { state: { from: '/checkout' } });
                        }
                      }}>{isLoggedIn ? 'CHECKOUT' : 'LOGIN TO CHECKOUT'}
                      </button>
                    </div>
                    
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CartPage;